import React from 'react';
import styled from 'styled-components';

function Shine(props) {
  const { shineDuration = 1.75 } = props;
  return <Container $shineDuration={shineDuration} />;
}

const Container = styled.div`
  animation: shineAnimation ${({ $shineDuration }) => `${$shineDuration}s`} linear infinite;
  background: linear-gradient(
    120deg,
    transparent,
    transparent,
    rgba(255, 255, 255, 0.5),
    transparent,
    transparent
  );
  content: '';
  height: 100%;
  position: absolute;
  top: 0;
  transform: translateX(-75%);
  width: 150%;
  z-index: 1;

  @keyframes shineAnimation {
    0% {
      transform: translateX(-75%);
    }
    33% {
      transform: translateX(75%);
    }
    100% {
      transform: translateX(75%);
    }
  }
`;

export default Shine;
